(function () {
	const DESCRIPTION_TRUNCATE_LENGTH = 80;
	const MOBILE_MEDIA_QUERY = "(max-width: 575px)";

	const truncateDescriptions = () => {
		const isMobile = window.matchMedia(MOBILE_MEDIA_QUERY).matches;

		document
			.querySelectorAll(".media-banner--layout-simple [data-media-banner-description]")
			.forEach((wrapper) => {
				const textEl = wrapper.querySelector("[data-description-text]");
				const toggleBtn = wrapper.querySelector("[data-description-toggle]");

				if (!textEl || !toggleBtn) return;

				if (!textEl.dataset.fullText) {
					textEl.dataset.fullText = textEl.textContent.trim();
				}

				const fullText = textEl.dataset.fullText;
				const moreLabel = toggleBtn.querySelector("[data-toggle-label-more]");
				const lessLabel = toggleBtn.querySelector("[data-toggle-label-less]");

				if (!isMobile || fullText.length <= DESCRIPTION_TRUNCATE_LENGTH) {
					textEl.textContent = fullText;
					toggleBtn.hidden = true;
					toggleBtn.setAttribute("aria-expanded", "true");
					delete wrapper.dataset.expanded;
					return;
				}

				toggleBtn.hidden = false;

				const isExpanded = wrapper.dataset.expanded === "true";

				if (isExpanded) {
					textEl.textContent = fullText;
					if (moreLabel) moreLabel.hidden = true;
					if (lessLabel) lessLabel.hidden = false;
					toggleBtn.setAttribute("aria-expanded", "true");
				} else {
					textEl.textContent = fullText.slice(0, DESCRIPTION_TRUNCATE_LENGTH).trim() + "...";
					if (moreLabel) moreLabel.hidden = false;
					if (lessLabel) lessLabel.hidden = true;
					toggleBtn.setAttribute("aria-expanded", "false");
				}

				if (!toggleBtn.dataset.bound) {
					toggleBtn.dataset.bound = "true";
					toggleBtn.addEventListener("click", () => {
						wrapper.dataset.expanded = wrapper.dataset.expanded === "true" ? "false" : "true";
						truncateDescriptions();
					});
				}
			});
	};

	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const stickyEffect = block.data("sticky-effect");

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		mediaBanner();
		truncateDescriptions();
		document.addEventListener("shopify:section:load", function () {
			mediaBanner();
			truncateDescriptions();
		});
	});

	window.addEventListener("resize", () => {
		clearTimeout(window.__mediaBannerDescResizeTimer);
		window.__mediaBannerDescResizeTimer = setTimeout(truncateDescriptions, 150);
	});
})();

//document.addEventListener("DOMContentLoaded", function () {
//	var stickyElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner"
//	);
//	var normalElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner-2"
//	);
//	var isSticky = false; // Track whether the element is sticky

//	window.addEventListener("scroll", function () {
//		var stickyTop = stickyElement.getBoundingClientRect().top;
//		var normalElementTop = normalElement.getBoundingClientRect().top;

//		// Add sticky class when sticky element reaches the top of the viewport
//		if (stickyTop <= 0 && !isSticky) {
//			stickyElement.classList.add("sticky-active");
//			isSticky = true; // Set sticky state to true
//		}

//		// Remove sticky class if the second section is in the viewport
//		if (normalElementTop <= 0 && isSticky) {
//			stickyElement.classList.remove("sticky-active");
//			isSticky = false; // Set sticky state to false
//		}
//	});
//});